import { reduxForm } from 'redux-form';
import Component, { DEFAULT_VALUES } from './ProcessUnblockCustomerForm';

const FormProcessUnblockCustomer = reduxForm({
  form: 'FormProcessUnblockCustomer',
  initialValues: DEFAULT_VALUES,
  enableReinitialize: true,
})(Component);

export default FormProcessUnblockCustomer;
